import { CashRegisterService } from "./../../../services/catalogs/CashRegisterService";
import { CreateCashRegisterDto } from "./../../../dtos/catalogs/cashregister/CreateCashRegisterDto";
import { CashRegisterDetail } from "./../../../components/Pages/Catalogs/CashRegister/CashRegisterDetail";
import React from "react";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupCashRegister } from "../../../components/Shared/NewForms/NFLookupCashRegister";
import CashRegisterList from "../../../components/Pages/Catalogs/CashRegister/CashRegisterList";

export const CashRegister: IAppEntity = {
  entityType: "catalog",
  title: "Cash Register",
  pluralTitle: "Cash Registers",
  apiUrl: "CashRegister",
  apiEnum: ReferenceTypes.CatalogCashRegister,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(CashRegisterDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(CashRegisterList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupCashRegister, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new CashRegisterService("CashRegisters"),
  getEmptyModel: () => {
    const model: CreateCashRegisterDto = {
      name: "",
    };
    return model;
  },
};
